import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { getAppointment, deleteAppointment, addAppointment, updateAppointment, getQuestionDetails } from '../../../Actions/appointmentAction';
import './reservations.css';
import moment from 'moment';

import Paper from '@material-ui/core/Paper';
import { ViewState, EditingState } from '@devexpress/dx-react-scheduler';
import {
    Scheduler,
    WeekView,
    MonthView,
    DayView,
    Appointments,
    Toolbar,
    ViewSwitcher,
    DateNavigator,
    TodayButton,
    AppointmentTooltip,
    AppointmentForm,
    EditRecurrenceMenu,
    AllDayPanel,
    Resources
} from '@devexpress/dx-react-scheduler-material-ui';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import Notes from '@material-ui/icons/Notes';
import Close from '@material-ui/icons/Close';
import Create from '@material-ui/icons/Create';
import TextFields from '@material-ui/icons/TextFields';
import Phone from '@material-ui/icons/Phone';
import Email from '@material-ui/icons/Email';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { connectProps } from '@devexpress/dx-react-core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import isEqual from 'lodash.isequal';
import { CSVLink } from "react-csv";
import csv_icon from './../../../images/csv_icon.png';
import excel_icon from './../../../images/excel_icon.png';
import pdf_icon from './../../../images/pdf_icon.png';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import xlsExport from 'xlsexport'
import { CirclePicker } from 'react-color'
import classNames from 'clsx';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { makeStyles } from '@material-ui/core/styles';
import Alert from "../../../Helper/SimpleAlert/alert";
import {Grid} from "@material-ui/core";

const styles=theme=>({

    addButton: {
        position: 'fixed',
        bottom: theme.spacing(1) * 4,
        right: theme.spacing(1) * 4,
        backgroundColor : '#851679',
        zIndex : '100',
    },

    addIcon: {
        width: '30px !important;',
        height: '30px !important;',
    },
});

const useStyles = makeStyles(theme => ({
    line: {
        height: '2px',
        borderTop: `2px ${theme.palette.primary.main} dotted`,
        width: '100%',
        transform: 'translate(0, -1px)',
    },
    circle: {
        width: theme.spacing(1.5),
        height: theme.spacing(1.5),
        borderRadius: '50%',
        transform: 'translate(-50%, -50%)',
        background: theme.palette.primary.main,
    },
    nowIndicator: {
        position: 'absolute',
        zIndex: 1,
        left: 0,
        top: ({ top }) => top,
    },
    shadedCell: {
        backgroundColor: fade(theme.palette.primary.main, 0.08),
        '&:hover': {
            backgroundColor: fade(theme.palette.primary.main, 0.12),
        },
        '&:focus': {
            backgroundColor: fade(theme.palette.primary.main, 0.20),
            outline: 0,
        },
    },
    shadedPart: {
        backgroundColor: fade(theme.palette.primary.main, 0.08),
        position: 'absolute',
        height: ({ shadedHeight }) => shadedHeight,
        width: '100%',
        left: 0,
        top: 0,
        'td:focus &': {
            backgroundColor: fade(theme.palette.primary.main, 0.12),
        },
    },
    // appointment: {
    //     backgroundColor: teal[300],
    //     '&:hover': {
    //         backgroundColor: teal[400],
    //     },
    // },
    // shadedAppointment: {
    //     backgroundColor: teal[200],
    //     '&:hover': {
    //         backgroundColor: teal[300],
    //     },
    // },
}));

const containerStyles = theme => ({
    container: {
        width: theme.spacing(68),
        padding: 0,
        paddingBottom: theme.spacing(2),
    },
    content: {
        padding: theme.spacing(2),
        paddingTop: 0,
    },
    header: {
        overflow: 'hidden',
        paddingTop: theme.spacing(0.5),
    },
    closeButton: {
        float: 'right',
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 2),
    },
    button: {
        marginLeft: theme.spacing(2),
    },
    picker: {
        marginRight: theme.spacing(2),
        '&:last-child': {
            marginRight: 0,
        },
        width: '50%',
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 0),
    },
    icon: {
        margin: theme.spacing(2, 0),
        marginRight: theme.spacing(2),
    },
    textField: {
        width: '100%',
    },

    MuiInputLabelformControl:{
        fontsize:'16px'
    },

    colorPickerDiv:{
        backgroundColor:'blue',
        // marginLeft:'30px'
    }
});

class AppointmentFormContainerBasic extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            appointmentChanges: {},
        };

        this.getAppointmentData = () => {
            const { appointmentData } = this.props;
            return appointmentData;
        };
        this.getAppointmentChanges = () => {
            const { appointmentChanges } = this.state;
            return appointmentChanges;
        };

        this.changeAppointment = this.changeAppointment.bind(this);
        this.commitAppointment = this.commitAppointment.bind(this);
    }

    changeAppointment({ field, changes }) {
        const nextChanges = {
            ...this.getAppointmentChanges(),
            [field]: changes,
        };
        this.setState({
            appointmentChanges: nextChanges,
        });
    }

    commitAppointment(type) {
        const { commitChanges } = this.props;
        const appointment = {
            ...this.getAppointmentData(),
            ...this.getAppointmentChanges(),
        };
        if (type === 'deleted') {
            commitChanges({ [type]: appointment.id });
        } else if (type === 'changed') {
            commitChanges({ [type]:  appointment  });
        } else {
            commitChanges({ [type]: appointment });
        }
        this.setState({
            appointmentChanges: {},
        });
    }

    handleChangeComplete = (color) => {
        this.changeAppointment({
            field:"color",
            changes: color.hex
        })

        this.setState({
            color: color.hex
        })

        // this.setState({ color: color.hex });
    };

    render() {
        const {
            classes,
            visible,
            visibleChange,
            appointmentData,
            cancelAppointment,
            target,
            onHide,
            questionDetails
        } = this.props;
        const { appointmentChanges } = this.state;

        const displayAppointmentData = {
            ...appointmentData,
            ...appointmentChanges,
        };

        const isNewAppointment = appointmentData.id === undefined;
        const applyChanges = isNewAppointment
            ? () => this.commitAppointment('added')
            : () => this.commitAppointment('changed');

        const textEditorProps = (field,name, type) => ({
            variant: 'outlined',
            onChange: ({ target: change }) => this.changeAppointment({
                field:(type === "control_textbox") ? [name] : [field],
                changes: change.value
            }),
            value: (type === "control_textbox") ? displayAppointmentData[name] || '' : displayAppointmentData[field] || '',
            label:  field[0].toUpperCase() + field.slice(1),
            className: classes.textField,
        });

        const pickerEditorProps = field => ({
            className: classes.picker,
            // keyboard: true,
            // ampm: false,
            value: displayAppointmentData[field],
            onChange: date => this.changeAppointment({
                field: [field],
                changes: date ? date.toDate() : new Date(displayAppointmentData[field]),
            }),
            inputVariant: 'outlined',
            format: 'MM/DD/YYYY HH:mm',
            onError: () => null,
        });

        const cancelChanges = () => {
            this.setState({
                appointmentChanges: {},
            });
            visibleChange();
            cancelAppointment();
        };

        return (
            <AppointmentForm.Overlay
                visible={visible}
                target={target}
                handleChangeDropDown
                onHide={onHide}
            >
                <div>
                    <div className={classes.header}>
                        <IconButton
                            className={classes.closeButton}
                            onClick={cancelChanges}
                        >
                            <Close color="action" />
                        </IconButton>
                    </div>
                    <div className={classes.content}>
                        <div className={classes.wrapper}>
                            <Create className={classes.icon} color="action" />
                            <TextField
                                {...textEditorProps('firstName',"","")}
                            />
                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <TextField
                                {...textEditorProps('lastName',"","")}
                            />
                        </div>
                        <div className={classes.wrapper}>
                            <Email className={classes.icon} color="action" />
                            <TextField
                                {...textEditorProps('email',"","")}
                            />
                        </div>
                        <div className={classes.wrapper}>
                            <Phone className={classes.icon} color="action" />
                            <TextField
                                {...textEditorProps('phoneNumber',"","")}
                            />
                        </div>
                        <div className={classes.wrapper}>
                            <CalendarToday className={classes.icon} color="action" />
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDateTimePicker
                                    label="Start Date"
                                    {...pickerEditorProps('startDate')}
                                />
                                <KeyboardDateTimePicker
                                    label="End Date"
                                    {...pickerEditorProps('endDate')}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className={classes.wrapper}>
                            <Notes className={classes.icon} color="action" />
                            <TextField
                                {...textEditorProps('notes',"","")}
                                multiline
                                rows="6"
                            />
                        </div>
                        { questionDetails ?
                            Object.keys(questionDetails).map(function (key) {
                                let value = questionDetails[key];

                                if ((value.type !== "control_button") && (value.typesetState !== "control_head") && (value.type !== "control_image")) {
                                    if (value.type === "control_textbox" && (value.hidden !== "Yes")) {
                                        {
                                            return (
                                                <div className={classes.wrapper}>
                                                    {/*<img src={edit_icon}*/}
                                                    {/*     style={{width: '10px', height: '10px'}}/>*/}
                                                    <TextFields className={classes.icon} color="action" />
                                                    <TextField {...textEditorProps(value.text, value.name, value.type)}/>
                                                </div>
                                            )
                                        }
                                    }
                                }
                            })
                            : ""
                        }

                        { questionDetails ?
                            Object.keys(questionDetails).map( (key) => {
                                let value = questionDetails[key];
                                if ((value.type !== "control_button") && (value.type !== "control_head") && (value.type !== "control_image")) {
                                    if (value.type === "control_widget" && value.name === "color") {
                                        {
                                            return (
                                                <div className={classes.wrapper}>
                                                    <div className={classes.icon} style={{
                                                        background: this.state.color,
                                                        width: 24,
                                                        height: 24,
                                                        color: 'white',
                                                        borderRadius: '50%',
                                                        position: 'absolute',
                                                        marginTop: '3px',
                                                        // transform: 'translateY(130%)',
                                                        // marginRight:'100px'

                                                    }}>
                                                    </div>
                                                    <div style={{marginRight:'auto', marginLeft:'35px'}}>
                                                        <CirclePicker onChange= {this.handleChangeComplete } />
                                                    </div>

                                                </div>
                                            )
                                        }
                                    }
                                }
                            })
                            : ""
                        }
                    </div>
                    <div className={classes.buttonGroup}>
                        {/*{!isNewAppointment && (*/}
                        {/*    <Button*/}
                        {/*        variant="outlined"*/}
                        {/*        color="secondary"*/}
                        {/*        className={classes.button}*/}
                        {/*        onClick={() => {*/}
                        {/*            visibleChange();*/}
                        {/*            this.commitAppointment('deleted');*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        Delete*/}
                        {/*    </Button>*/}
                        {/*)}*/}
                        <Button
                            variant="outlined"
                            color="primary"
                            className={classes.button}
                            onClick={() => {
                                visibleChange();
                                applyChanges();
                            }}
                        >
                            {isNewAppointment ? 'Create' : 'Save'}
                        </Button>
                    </div>
                </div>
            </AppointmentForm.Overlay>
        );
    }
}

const AppointmentFormContainer = withStyles(containerStyles, { name: 'AppointmentFormContainer' })(AppointmentFormContainerBasic);

const views = [{
    type: 'month',
    name: 'Auto Mode',
    maxAppointmentsPerCell: 'auto'
},];

const Appointment = ({
                         children, style, isShaded, ...restProps
                     }) => {
    const classes = useStyles();
    return (
        <Appointments.Appointment
            className={classNames({
                [classes.appointment]: true,
                [classes.shadedAppointment]: isShaded,
            })}
            {...restProps}
            style={{
                ...style,
                // backgroundColor: '#851679', //b764ac
                borderRadius: '8px',
                fontSize: '14px',
            }}
        >
            {children}
        </Appointments.Appointment>
    );
};

const SchedulerStyle =  ({
                             children, style, ...restProps
                         }) => (
    <WeekView.TimeScaleLabel
        {...restProps}
        style={{
            ...style,
            // backgroundColor: '#851679', //b764ac
            // //borderRadius: '8px',
            // // textStyle : {
            // //     fontSize : '20px'
            // // },
            // label:{
            //     text: {
            //         fontSize: '2.5rem !important;',
            //     // marginHorizontal: '2rem'
            //     },
            // },
            // fontSize: '1.7rem !important;',
            // color: '#851679',
        }}
    >
        {children}
    </WeekView.TimeScaleLabel>
);

const mapAppointmentData = appointment => ({
    ...appointment,
    title : appointment.name,
});

class ReservationsTable extends React.Component {

    constructor(props){
        super(props);
        this.state={
            data: [],
            exportData: [],
            pdfExportDataKey:[],
            pdfExportData:[],
            currentViewName: 'week',
            // currentDate: '2020-08-01',
            addedAppointment: {},
            appointmentChanges: {},
            editingAppointmentId: undefined,
            cellDuration: 30,
            confirmationVisible: false,
            editingFormVisible: false,
            deletedAppointmentId: undefined,
            editingAppointment: undefined,
            previousAppointment: undefined,
            isNewAppointment: false,
            jsonObject:{},
        }

        this.currentViewNameChange = (currentViewName) => {
            this.setState({ currentViewName });
        };

        this.currentDateChange = (currentDate) => {     this.setState({ currentDate }); };

        this.toggleConfirmationVisible = this.toggleConfirmationVisible.bind(this);
        this.commitDeletedAppointment = this.commitDeletedAppointment.bind(this);
        this.toggleEditingFormVisibility = this.toggleEditingFormVisibility.bind(this);

        this.commitChanges = this.commitChanges.bind(this);
        this.onEditingAppointmentChange = this.onEditingAppointmentChange.bind(this);
        this.onAddedAppointmentChange = this.onAddedAppointmentChange.bind(this);
        this.appointmentForm = connectProps(AppointmentFormContainer, () => {
            const {
                editingFormVisible,
                editingAppointment,
                data,
                addedAppointment,
                isNewAppointment,
                previousAppointment,
                questionDetails
            } = this.state;

            const currentAppointment = data
                    .filter(appointment => editingAppointment && appointment.id === editingAppointment.id)[0]
                || addedAppointment;
            const cancelAppointment = () => {
                if (isNewAppointment) {
                    this.setState({
                        editingAppointment: previousAppointment,
                        isNewAppointment: false,
                    });
                }
            };

            return {
                visible: editingFormVisible,
                appointmentData: currentAppointment,
                commitChanges: this.commitChanges,
                visibleChange: this.toggleEditingFormVisibility,
                onEditingAppointmentChange: this.onEditingAppointmentChange,
                cancelAppointment,
                questionDetails
            };
        });
    }

    componentDidMount() {
        this.props.getAppointment(`https://api.jotform.com/form/${this.props.user.BusinessUser.AppointmentFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000`);

        this.props.getQuestionDetails(`https://api.jotform.com/form/${this.props.user.BusinessUser.AppointmentFormId}/questions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000`);
    }

    componentWillMount() {
        localStorage.setItem('appointmentCount','');
    }

    componentWillUnmount(){
        clearInterval(this.interval);

        if (this.props.appointment && this.props.appointment.length > 0) {
            localStorage.setItem('appointmentCount',this.props.appointment.length);
        }

        this.setState({
            isNewAppointment: false
        })
    }

    componentDidUpdate(nextProps, prevState) {

        if (!isEqual(nextProps.appointment, this.props.appointment) || prevState.isNewAppointment || (prevState.editingAppointment && Object.keys(prevState.editingAppointment).length!==0)) {

            if (prevState.editingAppointment && Object.keys(prevState.editingAppointment).length!==0) {
                // this.setState({
                //     editingAppointment : undefined
                // })
            }

            if (prevState.isAddAPICalled) {
                this.setState({
                    isNewAppointment: false,
                    jsonObject : {},
                    isAddAPICalled : false

                })
            }
            else if(!prevState.jsonObject) {
                this.setState({
                    isNewAppointment: false
                })
            }

            setTimeout(() => {
                this.props.getAppointment(`https://api.jotform.com/form/${this.props.user.BusinessUser.AppointmentFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000`);
            }, 1000);
        }
        this.appointmentForm.update();
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.appointment) {
            let valuesArrObj = []
            let valuesArrExportObj = []
            let valuesArrResourceObj = []
            let pdfKeysArrResourceObj = []
            let pdfValuesArrResourceObj = []
            {
                nextProps.appointment && nextProps.appointment.length > 0 && nextProps.appointment.slice(0, nextProps.appointment.length).map((appointment, index) => {
                    let obj = nextProps.appointment[index].answers;
                    var dict = {};
                    dict["FormId"] = nextProps.appointment[index].form_id
                    dict["Id"] = nextProps.appointment[index].id
                    Object.keys(obj).map(function (key) {
                        let value = obj[key];
                        if ((value.type !== "control_button") && (value.type !== "control_head") && (value.type !== "control_image")) {
                            if (value.type === "control_fullname") {
                                if (value.answer) {
                                    dict["Name"] = value.prettyFormat ? value.prettyFormat : ""
                                    dict["FirstName"] = value.answer.first ? value.answer.first : ""
                                    dict["LastName"] = value.answer.last ? value.answer.last : ""
                                }
                                dict["NameQuestionId"] = key

                            }
                            if (value.type === "control_phone") {
                                if (value.prettyFormat) {
                                    if (value.answer.phone !== "" ) {
                                        dict["PhoneNumber"] = value.prettyFormat ? value.prettyFormat : ""
                                    }
                                }
                                else if (value.answer !== "" ) {
                                    dict["PhoneNumber"] = value.answer ? value.answer : ""
                                }
                                dict["PhoneNumberQuestionId"] = key
                            }
                            if (value.type === "control_email") {
                                if (value.answer) {
                                    dict["Email"] = value.answer ? value.answer : ""
                                }
                                dict["EmailQuestionId"] = key
                            }
                            if (value.type === "control_appointment") {
                                if (value.answer) {
                                    // let gmtDateTime = moment.utc(value.answer.date, "YYYY-MM-DDTHH:mm:ss")
                                    //  let localStartDate = value.answer.date.local().format('YYYY-MM-DDTHH:mm:ss');

                                    const startDate = moment(value.answer.date).format('YYYY-MM-DDTHH:mm:ss');
                                    dict["StartDate"] = startDate

                                    let date = new Date(dict["StartDate"]).getTime() + Number(value.answer.duration * 60 * 1000)

                                    // let gmtEndDateTime = moment.utc(new Date(date), "YYYY-MM-DDTHH:mm:ss")
                                    // let localEndDate = gmtEndDateTime.local().format('YYYY-MM-DDTHH:mm:ss');

                                    const endDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');
                                    dict["EndDate"] = endDate
                                }
                                dict["DateQuestionId"] = key
                            }
                            if (value.type === "control_textarea") {
                                if (value.answer) {
                                    dict["Notes"] = value.answer ? value.answer : ""
                                }
                                dict["NotesQuestionId"] = key
                            }
                            if (value.type === "control_textbox" && value.name === "extra1") {
                                if (value.answer) {
                                    dict["Extra1"] = value.answer ? value.answer : ""
                                }
                                dict["Extra1QuestionId"] = key
                            }
                            if (value.type === "control_textbox" && value.name === "extra2") {
                                if (value.answer) {
                                    dict["Extra2"] = value.answer ? value.answer : ""
                                }
                                dict["Extra2QuestionId"] = key
                            }
                            if (value.type === "control_textbox" && value.name === "extra3") {
                                if (value.answer) {
                                    dict["Extra3"] = value.answer ? value.answer : ""
                                }
                                dict["Extra3QuestionId"] = key
                            }
                            if (value.type === "control_widget" && value.name === "color") {
                                if (value.answer) {
                                    dict["Color"] = value.answer ? value.answer : ""
                                }
                                dict["ColorId"] = key
                            }
                        }
                    })
                    valuesArrObj.push({
                        name: dict["Name"],
                        startDate: dict["StartDate"],
                        endDate: dict["EndDate"],
                        formId: dict["FormId"],
                        id: dict["Id"],
                        email: dict["Email"],
                        phoneNumber: dict["PhoneNumber"],
                        firstName: dict["FirstName"],
                        lastName: dict["LastName"],
                        nameQuestionId: dict["NameQuestionId"],
                        phoneNumberQuestionId: dict["PhoneNumberQuestionId"],
                        emailQuestionId: dict["EmailQuestionId"],
                        dateQuestionId: dict["DateQuestionId"],
                        notes : dict["Notes"],
                        notesQuestionId : dict["NotesQuestionId"],
                        extra1 : dict["Extra1"],
                        extra1QuestionId : dict["Extra1QuestionId"],
                        extra2 : dict["Extra2"],
                        extra2QuestionId : dict["Extra2QuestionId"],
                        extra3 : dict["Extra3"],
                        extra3QuestionId : dict["Extra3QuestionId"],
                        color : dict["Color"],
                        colorId : dict["ColorId"],
                    })

                    if (nextProps.questionDetails) {
                        Object.keys(nextProps.questionDetails).map(function (key) {
                            let value = nextProps.questionDetails[key];

                            if (value.type === "control_textbox" && value.name === "extra1" && (value.hidden !== "Yes")) {
                                dict["Extra1Question"] = value.text
                            }
                            if (value.type === "control_textbox" && value.name === "extra2" && (value.hidden !== "Yes")) {
                                dict["Extra2Question"] = value.text
                            }
                            if (value.type === "control_textbox" && value.name === "extra3" && (value.hidden !== "Yes")) {
                                dict["Extra3Question"] = value.text
                            }
                        });
                    }

                    const startDate = moment(dict["StartDate"]).format('MMMM Do, YYYY');
                    const startTime = moment(dict["StartDate"]).format('h:mm a');
                    var startDateTimeValue = startDate + ' at ' + startTime

                    if (dict["Extra1Question"] && dict["Extra2Question"] && dict["Extra3Question"]) {
                        valuesArrExportObj.push({
                            "First name": dict["FirstName"],
                            "Last name": dict["LastName"],
                            "Email": dict["Email"],
                            "Phone number": dict["PhoneNumber"],
                            "Date/time": startDateTimeValue,
                            "Notes": dict["Notes"],
                            [dict["Extra1Question"]]: dict["Extra1"],
                            [dict["Extra2Question"]]: dict["Extra2"],
                            [dict["Extra3Question"]]: dict["Extra3"],
                        })
                    }
                    else if (dict["Extra1Question"] && dict["Extra2Question"]) {
                        valuesArrExportObj.push({
                            "First name": dict["FirstName"],
                            "Last name": dict["LastName"],
                            "Email": dict["Email"],
                            "Phone number": dict["PhoneNumber"],
                            "Date/time": startDateTimeValue,
                            "Notes": dict["Notes"],
                            [dict["Extra1Question"]]: dict["Extra1"],
                            [dict["Extra2Question"]]: dict["Extra2"],
                        })
                    }
                    else if (dict["Extra1Question"] && dict["Extra3Question"]) {
                        valuesArrExportObj.push({
                            "First name": dict["FirstName"],
                            "Last name": dict["LastName"],
                            "Email": dict["Email"],
                            "Phone number": dict["PhoneNumber"],
                            "Date/time": startDateTimeValue,
                            "Notes": dict["Notes"],
                            [dict["Extra1Question"]]: dict["Extra1"],
                            [dict["Extra3Question"]]: dict["Extra3"],
                        })
                    }
                    else if (dict["Extra1Question"]) {
                        valuesArrExportObj.push({
                            "First name": dict["FirstName"],
                            "Last name": dict["LastName"],
                            "Email": dict["Email"],
                            "Phone number": dict["PhoneNumber"],
                            "Date/time": startDateTimeValue,
                            "Notes": dict["Notes"],
                            [dict["Extra1Question"]]: dict["Extra1"],
                        })
                    }
                    else if (dict["Extra2Question"] && dict["Extra3Question"]) {
                        valuesArrExportObj.push({
                            "First name": dict["FirstName"],
                            "Last name": dict["LastName"],
                            "Email": dict["Email"],
                            "Phone number": dict["PhoneNumber"],
                            "Date/time": startDateTimeValue,
                            "Notes": dict["Notes"],
                            [dict["Extra2Question"]]: dict["Extra2"],
                            [dict["Extra3Question"]]: dict["Extra3"],
                        })
                    }
                    else if (dict["Extra2Question"]) {
                        valuesArrExportObj.push({
                            "First name": dict["FirstName"],
                            "Last name": dict["LastName"],
                            "Email": dict["Email"],
                            "Phone number": dict["PhoneNumber"],
                            "Date/time": startDateTimeValue,
                            "Notes": dict["Notes"],
                            [dict["Extra2Question"]]: dict["Extra2"],
                        })
                    }
                    else if (dict["Extra3Question"]) {
                        valuesArrExportObj.push({
                            "First name": dict["FirstName"],
                            "Last name": dict["LastName"],
                            "Email": dict["Email"],
                            "Phone number": dict["PhoneNumber"],
                            "Date/time": startDateTimeValue,
                            "Notes": dict["Notes"],
                            [dict["Extra3Question"]]: dict["Extra3"],
                        })
                    }
                    else {
                        valuesArrExportObj.push({
                            "First name": dict["FirstName"],
                            "Last name": dict["LastName"],
                            "Email": dict["Email"],
                            "Phone number": dict["PhoneNumber"],
                            "Date/time": startDateTimeValue,
                            "Notes": dict["Notes"],
                        })
                    }

                    valuesArrResourceObj.push({
                        text: dict["Name"],
                        id: dict["Name"],
                        color : dict["Color"] ? dict["Color"] : '#851679',
                    })
                })

                let dat = valuesArrObj.map(mapAppointmentData)
                let exportDat = valuesArrExportObj
                let resourceDat = valuesArrResourceObj

                const resourceArr = [{
                    fieldName: 'name',
                    title: 'name',
                    instances: resourceDat,
                }];

                exportDat && exportDat.length > 0 && exportDat.slice(0, 1).map((data) => {
                    let obj1 = data;

                    Object.keys(obj1).map(function (key) {
                        if (key !== "endDate") {
                            pdfKeysArrResourceObj.push(
                                key
                            )
                        }
                    })
                })

                exportDat && exportDat.length > 0 && exportDat.slice(0, exportDat.length).map((data) => {
                    let obj1 = data;

                    let pdfInnerValuesArrResourceObj = []
                    Object.keys(obj1).map(function (key) {
                        if (key === "Date/time") {
                            let value = obj1[key];
                            const startDate = moment(value).format('MMMM Do, YYYY');
                            const startTime = moment(value).format('h:mm a');
                            value = startDate + ' at ' + startTime
                            pdfInnerValuesArrResourceObj.push(
                                value
                            )
                        }
                        else {
                            let value = obj1[key];
                            pdfInnerValuesArrResourceObj.push(
                                value
                            )
                        }
                    })

                    pdfValuesArrResourceObj.push(
                        pdfInnerValuesArrResourceObj
                    )
                })

                this.setState({
                    data: dat,
                    exportData :exportDat,
                    pdfExportDataKey : pdfKeysArrResourceObj,
                    pdfExportData : pdfValuesArrResourceObj,
                    resourceData : resourceArr,
                });
            }

            this.appointmentForm.update();
        }

        if (this.state.isNewAppointment && nextProps.questionDetails && this.state.addedAppointmentDetails) {

            let { addedAppointmentDetails } = this.state;

            let obj = nextProps.questionDetails;
            var dict = {};
            Object.keys(obj).map(function (key) {
                let value = obj[key];

                if ((value.type !== "control_button") && (value.type !== "control_head") && (value.type !== "control_image")) {
                    if (value.type === "control_fullname") {
                        dict[key] = { "first" : addedAppointmentDetails['firstName'], "last" : addedAppointmentDetails['lastName']}
                    }
                    if (value.type === "control_phone") {
                        dict[key] = addedAppointmentDetails['phoneNumber']
                    }
                    if (value.type === "control_email") {
                        dict[key] = addedAppointmentDetails['email']
                    }
                    if (value.type === "control_appointment") {
                        var startDate = undefined
                        var endDate = undefined
                        if (addedAppointmentDetails['startDate']) {
                            startDate = new Date(addedAppointmentDetails['startDate'])
                        }

                        if (addedAppointmentDetails['endDate']) {
                            endDate = new Date(addedAppointmentDetails['endDate'])
                        }

                        var diffMs = (endDate - startDate);
                        let diffMins = Math.floor(diffMs/1000/60);

                        dict[key] = { "date" : addedAppointmentDetails['startDate'], "duration" : diffMins}//"timezone" : "Asia/India (GMT+05:30)"
                    }
                    if (value.type === "control_textarea") {
                        dict[key] = addedAppointmentDetails['notes']
                    }
                    if (value.type === "control_textbox" && value.name === "extra1") {
                        dict[key] = addedAppointmentDetails['extra1']
                    }
                    if (value.type === "control_textbox" && value.name === "extra2") {
                        dict[key] = addedAppointmentDetails['extra2']
                    }
                    if (value.type === "control_textbox" && value.name === "extra3") {
                        dict[key] = addedAppointmentDetails['extra3']
                    }
                    if (value.type === "control_widget" && value.name === "color") {
                        dict[key] = addedAppointmentDetails['color']
                    }
                }
            })

            this.setState({
                jsonObject: dict,
                addedAppointmentDetails : undefined,
            }, () => {
                this.callAddApi();
            })
        }

        if (nextProps && nextProps.questionDetails) {
            this.setState({
                questionDetails : nextProps.questionDetails,
            })
            // localStorage.setItem('questionDetails', nextProps.questionDetails);
        }
    }

    onEditingAppointmentChange(editingAppointment) {
        this.setState({ editingAppointment });
    }

    onAddedAppointmentChange(addedAppointment) {
        this.setState({ addedAppointment });
        const { editingAppointment } = this.state;
        if (editingAppointment !== undefined) {
            this.setState({
                previousAppointment: editingAppointment,
            });
        }
        this.setState({ editingAppointment: undefined, isNewAppointment: true });
    }

    setDeletedAppointmentId(id) {
        this.setState({ deletedAppointmentId: id });
    }

    toggleEditingFormVisibility() {
        const { editingFormVisible } = this.state;
        this.setState({
            editingFormVisible: !editingFormVisible,
        });
    }

    toggleConfirmationVisible() {
        const { confirmationVisible } = this.state;
        this.setState({ confirmationVisible: !confirmationVisible });
    }

    commitDeletedAppointment() {
        this.setState((state) => {
            const { data, deletedAppointmentId } = state;
            const nextData = data.filter(appointment => appointment.id !== deletedAppointmentId);

            this.props.deleteAppointment(`https://api.jotform.com/submission/${deletedAppointmentId}?apiKey=09ec9741da1cb60e6cf174b550577672`).then(() => {
                this.setState({
                    showAlert:!this.state.showAlert,
                    showSuccess:!this.state.showSuccess,
                    msg:'Your appointment has been deleted.',
                    data: nextData,
                    deletedAppointmentId: null
                });
            });
        });
        this.toggleConfirmationVisible();
    }

    commitChanges({ added, changed, deleted }) {
        // this.setState((state) => {
        let { data } = this.state;
        if (added) {

            if (!added['startDate']) {
                added['startDate'] = new Date()
            }

            if (!added['endDate']) {
                added['endDate'] = new Date().setMinutes( new Date().getMinutes() + 30 )
            }

            this.setState({
                addedAppointmentDetails: added,
            })

            const startingAddedId = data.length > 0 ? data[data.length - 1].id + 1 : 0;
            data = [...data, { id: startingAddedId, ...added }];
        }
        if (changed) {

            let startDate = new Date(changed['startDate'])
            let endDate = new Date(changed['endDate'])

            var diffMs = (endDate - startDate);
            let diffMins = Math.floor(diffMs/1000/60);

            var dict = {};
            dict[changed['nameQuestionId']] = { "first" : changed['firstName'], "last" : changed['lastName']}
            dict[changed['emailQuestionId']] = changed['email']
            dict[changed['phoneNumberQuestionId']] = changed['phoneNumber']
            dict[changed['dateQuestionId']] = { "date" : changed['startDate'], "duration" : diffMins} //"timezone" : "Asia/India (GMT+05:30)"
            dict[changed['notesQuestionId']] = changed['notes']
            dict[changed['extra1QuestionId']] = changed['extra1']
            dict[changed['extra2QuestionId']] = changed['extra2']
            dict[changed['extra3QuestionId']] = changed['extra3']
            dict[changed['colorId']] = changed['color']

            const index = data.findIndex(p => p.id === changed['id'])

            var dat =  data
            dat [index] = changed
            dat[index]['title'] = changed['firstName'] + " " + changed['lastName']
            dat[index]['name'] = changed['firstName'] + " " + changed['lastName']

            data = dat

            this.setState({
                jsonObject: dict,
            }, () => {
                this.callUpdateApi(changed['id']);
            })

            this.forceUpdate()
        }
        if (deleted !== undefined) {
            this.setDeletedAppointmentId(deleted);
            this.toggleConfirmationVisible();
        }
        return { data, addedAppointment: {} };
        // });
    }

    callAddApi = () => {
        let {jsonObject} = this.state;
        this.setState({
            isAddAPICalled : true
        })
        this.props.addAppointment(`https://api.jotform.com/form/${this.props.user.BusinessUser.AppointmentFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672`,jsonObject).then(() => {

            const appointmentCount = localStorage.getItem('appointmentCount');
            localStorage.setItem('appointmentCount',appointmentCount + 1);

            this.setState({
                showAlert:!this.state.showAlert,
                showSuccess:!this.state.showSuccess,
                msg:'Your appointment has been added.',
            });
        });
    };

    callUpdateApi = (submissionId) => {
        let {jsonObject} = this.state;
        this.props.updateAppointment(`https://api.jotform.com/submission/${submissionId}?apiKey=09ec9741da1cb60e6cf174b550577672`,jsonObject).then(() => {
            this.setState({
                showAlert:!this.state.showAlert,
                showSuccess:!this.state.showSuccess,
                msg:'Your appointment updates have been saved.',
            });
        });
    };

    alertCallback=()=>{
        this.setState({showAlert:!this.state.showAlert})
    };

    render(){
        const { classes } = this.props;
        let { data, exportData, pdfExportDataKey, pdfExportData, resourceData, currentViewName ,currentDate, confirmationVisible, editingFormVisible } = this.state;

        let arrFilteredData = []
        if (this.state && this.state.currentViewName === "Day") {
            var today = new Date();
            if (currentDate !== undefined) {
                today =  currentDate
            }
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
            today = dd + '/' + mm + '/' + yyyy;

            {data.filter(appointmentObj => moment(appointmentObj.startDate).format('DD/MM/YYYY') == today).map( function (filteredappointmentObj) {
                // console.log("Filtered Data:- " + filteredappointmentObj)

                if (filteredappointmentObj) {

                    arrFilteredData.push({
                        filteredappointmentObj
                    })
                }
            })}
        }
        else if (this.state && this.state.currentViewName === "week") {
            var today = new Date();
            if (currentDate !== undefined) {
                today =  currentDate
            }
            var day = today.getDay();

            var firstday = new Date(today.getTime() - 60*60*24* day*1000) ; // will return firstday (i.e. Sunday) of the week
            var dd1 = String(firstday.getDate()).padStart(2, '0');
            var mm1 = String(firstday.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy1 = firstday.getFullYear();

            var lastday = new Date(firstday.getTime() + 60 * 60 *24 * 6 * 1000); // adding (60*60*6*24*1000) means adding six days to the firstday which results in lastday (Saturday) of the week
            var dd2 = String(lastday.getDate()).padStart(2, '0');
            var mm2 = String(lastday.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy2 = lastday.getFullYear();

            firstday = mm1 + '/' + dd1 + '/' + yyyy1;
            lastday = mm2 + '/' + dd2 + '/' + yyyy2;

            {data.filter(appointmentObj => moment(appointmentObj.startDate).format('MM/DD/YYYY') >= firstday && moment(appointmentObj.startDate).format('MM/DD/YYYY') <= lastday).map( function (filteredappointmentObj) {

                if (filteredappointmentObj) {

                    arrFilteredData.push({
                        filteredappointmentObj
                    })
                }
            })}
        }
        else if (this.state && this.state.currentViewName === "Month") {
            var today = new Date();
            if (currentDate !== undefined) {
                today =  currentDate
            }

            var firstday = new Date(today.getFullYear(), today.getMonth(), 1);

            var lastday = new Date(today.getFullYear(), today.getMonth() + 1, 0);

            var dd1 = String(firstday.getDate()).padStart(2, '0');
            var mm1 = String(firstday.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy1 = firstday.getFullYear();

            var dd2 = String(lastday.getDate()).padStart(2, '0');
            var mm2 = String(lastday.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy2 = lastday.getFullYear();

            firstday = mm1 + '/' + dd1 + '/' + yyyy1;
            lastday = mm2 + '/' + dd2 + '/' + yyyy2;

            {data.filter(appointmentObj => moment(appointmentObj.startDate).format('MM/DD/YYYY') >= firstday && moment(appointmentObj.startDate).format('MM/DD/YYYY') <= lastday).map( function (filteredappointmentObj) {
                // var dasd = moment(filteredappointmentObj.startDate).format('DD/MM/YYYY');
                //
                // console.log("Filtered Data:- " + dasd)

                if (filteredappointmentObj) {

                    arrFilteredData.push({
                        filteredappointmentObj
                    })
                }
            })}
        }

        var today = new Date()
        var fileName = "Reservations_" + (today.getMonth() + 1) + "-" + today.getDate() + "-" + today.getFullYear()

        const toPdf = () => {
            const doc = new jsPDF()
            doc.autoTable({
                head: [pdfExportDataKey],
                body: pdfExportData,
                columnStyles: { halign: 'center' } ,
                // theme: 'plain',
                styles: {
                    fontSize: 6,
                },
            })
            doc.save(fileName + ".pdf")
        }

        const toExcel = () => {
            const xls = new xlsExport(exportData)
            xls.exportToXLS(fileName + ".xls")
        }

        return(
            <div style={{ overflowX: "auto"}}>
                <Grid container spacing={24}>
                    <Alert onClose={this.alertCallback} showSuccess={this.state.showAlert} showError={false} Msg={this.state.msg}/>
                </Grid>
                <Paper>
                    <div style={{}}>
                        <label style={{fontSize:'12px'}}>Download as:</label>
                        <CSVLink data={exportData} style={{
                            fontSize: '10px',
                            color: 'black',
                            textDecoration: 'none',
                            fontStyle: 'normal',
                        }} filename={fileName}>
                            <img src={csv_icon}
                                 style={{margin: '0 0px 0 10px',width: '25px'}}/>
                            <label style={{fontSize:'11px',margin: '0 6px 0 0px',fontWeight: 'normal', cursor: 'pointer'}}>CSV</label>
                        </CSVLink>

                        <img src={excel_icon} style={{width: '20px', height: '25px',cursor: 'pointer'}} onClick={() => toExcel()}/>
                        <label style={{fontSize:'11px',margin: '0 6px 0 3px',fontWeight: 'normal', cursor: 'pointer'}} onClick={() => toExcel()}>Excel</label>

                        <img src={pdf_icon} style={{width: '25px',cursor: 'pointer'}} onClick={() => toPdf()}/>
                        <label style={{fontSize:'11px',margin: '0 6px 0 1   px',fontWeight: 'normal',cursor: 'pointer'}} onClick={() => toPdf()}>PDF</label>

                        {arrFilteredData && arrFilteredData.length > 0 && currentViewName === "Day" ?
                            arrFilteredData.slice(0, 1).map(() => {
                                var today = new Date();
                                if (currentDate !== undefined) {
                                    today =  currentDate
                                }
                                var dd = String(today.getDate()).padStart(2, '0');
                                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                                var yyyy = today.getFullYear();
                                today = mm + '/' + dd + '/' + yyyy;

                                return (
                                    <div style={{height: '40px', backgroundColor: '#4CAF50', float: 'right', display: 'flex'}}>
                                        <label style={{
                                            color: 'white',
                                            alignSelf: 'center',
                                            padding: '15px',
                                            fontSize: '12px',
                                            marginTop: '5px',
                                            fontWeight: 'normal',
                                            textAlign: 'center'
                                        }}>You have {arrFilteredData.length} {arrFilteredData.length == 1 ? 'reservation' : 'reservations'} on {today}</label>
                                    </div>
                                )
                            }) : (()=> {
                                if (arrFilteredData.length === 0) {
                                    if (currentViewName === "Day") {
                                        var today = new Date();
                                        if (currentDate !== undefined) {
                                            today = currentDate
                                        }
                                        var dd = String(today.getDate()).padStart(2, '0');
                                        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                                        var yyyy = today.getFullYear();
                                        today = mm + '/' + dd + '/' + yyyy;

                                        return (
                                            <div style={{
                                                height: '40px',
                                                backgroundColor: '#4CAF50',
                                                float: 'right',
                                                display: 'flex'
                                            }}>
                                                <label style={{
                                                    color: 'white',
                                                    alignSelf: 'center',
                                                    padding: '15px',
                                                    fontSize: '12px',
                                                    marginTop: '5px',
                                                    fontWeight: 'normal',
                                                    textAlign: 'center'
                                                }}>You have 0 reservation on {today}</label>
                                            </div>
                                        )
                                    } else if (currentViewName === "week") {
                                        var today = new Date();
                                        if (currentDate !== undefined) {
                                            today = currentDate
                                        }
                                        var day = today.getDay();

                                        var firstday = new Date(today.getTime() - 60 * 60 * 24 * day * 1000); // will return firstday (i.e. Sunday) of the week
                                        var dd1 = String(firstday.getDate()).padStart(2, '0');
                                        var mm1 = String(firstday.getMonth() + 1).padStart(2, '0'); //January is 0!
                                        var yyyy1 = firstday.getFullYear();

                                        var lastday = new Date(firstday.getTime() + 60 * 60 * 24 * 6 * 1000); // adding (60*60*6*24*1000) means adding six days to the firstday which results in lastday (Saturday) of the week
                                        var dd2 = String(lastday.getDate()).padStart(2, '0');
                                        var mm2 = String(lastday.getMonth() + 1).padStart(2, '0'); //January is 0!
                                        var yyyy2 = lastday.getFullYear();

                                        firstday = mm1 + '/' + dd1 + '/' + yyyy1;
                                        lastday = mm2 + '/' + dd2 + '/' + yyyy2;
                                        return (
                                            <div style={{
                                                height: '40px',
                                                backgroundColor: '#4CAF50',
                                                float: 'right',
                                                display: 'flex'
                                            }}>
                                                <label style={{
                                                    color: 'white',
                                                    alignSelf: 'center',
                                                    padding: '15px',
                                                    fontSize: '12px',
                                                    marginTop: '5px',
                                                    fontWeight: 'normal',
                                                    textAlign: 'center'
                                                }}>You have 0 reservation for week of {firstday} - {lastday}</label>
                                            </div>
                                        )
                                    } else if (currentViewName === "Month") {
                                        var today = new Date();
                                        if (currentDate !== undefined) {
                                            today = currentDate
                                        }

                                        var firstday = new Date(today.getFullYear(), today.getMonth(), 1);

                                        var lastday = new Date(today.getFullYear(), today.getMonth() + 1, 0);

                                        var dd1 = String(firstday.getDate()).padStart(2, '0');
                                        var mm1 = String(firstday.getMonth() + 1).padStart(2, '0'); //January is 0!
                                        var yyyy1 = firstday.getFullYear();

                                        var dd2 = String(lastday.getDate()).padStart(2, '0');
                                        var mm2 = String(lastday.getMonth() + 1).padStart(2, '0'); //January is 0!
                                        var yyyy2 = lastday.getFullYear();

                                        firstday = mm1 + '/' + dd1 + '/' + yyyy1;
                                        lastday = mm2 + '/' + dd2 + '/' + yyyy2;

                                        // console.log("FIRST DAY:- " + firstday + "LAST DAY:-" + lastday)

                                        return (
                                            <div style={{
                                                height: '40px',
                                                backgroundColor: '#4CAF50',
                                                float: 'right',
                                                display: 'flex'
                                            }}>
                                                <label style={{
                                                    color: 'white',
                                                    alignSelf: 'center',
                                                    padding: '15px',
                                                    fontSize: '12px',
                                                    marginTop: '5px',
                                                    fontWeight: 'normal',
                                                    textAlign: 'center'
                                                }}>You
                                                    have 0 reservation for month
                                                    of: {today.toLocaleString('default', {month: 'long'})}</label>
                                            </div>
                                        )
                                    }
                                }
                            })()
                        }

                        {arrFilteredData && arrFilteredData.length > 0 && currentViewName === "week" &&
                        arrFilteredData.slice(0, 1).map(() => {
                            var today = new Date();
                            if (currentDate !== undefined) {
                                today =  currentDate
                            }
                            var day = today.getDay();

                            var firstday = new Date(today.getTime() - 60*60*24* day*1000) ; // will return firstday (i.e. Sunday) of the week
                            var dd1 = String(firstday.getDate()).padStart(2, '0');
                            var mm1 = String(firstday.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy1 = firstday.getFullYear();

                            var lastday = new Date(firstday.getTime() + 60 * 60 *24 * 6 * 1000); // adding (60*60*6*24*1000) means adding six days to the firstday which results in lastday (Saturday) of the week
                            var dd2 = String(lastday.getDate()).padStart(2, '0');
                            var mm2 = String(lastday.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy2 = lastday.getFullYear();

                            firstday = mm1 + '/' + dd1 + '/' + yyyy1;
                            lastday = mm2 + '/' + dd2 + '/' + yyyy2;
                            return (
                                <div style={{
                                    height: '40px',
                                    backgroundColor: '#4CAF50',
                                    float: 'right',
                                    display: 'flex'
                                }}>
                                    <label style={{
                                        color: 'white',
                                        alignSelf: 'center',
                                        padding: '15px',
                                        fontSize: '12px',
                                        marginTop: '5px',
                                        fontWeight: 'normal',
                                        textAlign: 'center'
                                    }}>You have {arrFilteredData.length} {arrFilteredData.length == 1 ? 'reservation' : 'reservations'} for week of {firstday} - {lastday}</label>
                                </div>
                            )
                        })
                        }

                        {arrFilteredData && arrFilteredData.length > 0 && currentViewName === "Month" &&
                        arrFilteredData.slice(0, 1).map(() => {
                            var today = new Date();
                            if (currentDate !== undefined) {
                                today =  currentDate
                            }

                            var firstday = new Date(today.getFullYear(), today.getMonth(), 1);

                            var lastday = new Date(today.getFullYear(), today.getMonth() + 1, 0);

                            var dd1 = String(firstday.getDate()).padStart(2, '0');
                            var mm1 = String(firstday.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy1 = firstday.getFullYear();

                            var dd2 = String(lastday.getDate()).padStart(2, '0');
                            var mm2 = String(lastday.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy2 = lastday.getFullYear();

                            firstday = mm1 + '/' + dd1 + '/' + yyyy1;
                            lastday = mm2 + '/' + dd2 + '/' + yyyy2;

                            // console.log("FIRST DAY:- " + firstday + "LAST DAY:-" + lastday)

                            return (
                                <div style={{
                                    height: '40px',
                                    backgroundColor: '#4CAF50',
                                    float: 'right',
                                    display: 'flex'
                                }}>
                                    <label style={{
                                        color: 'white',
                                        alignSelf: 'center',
                                        padding: '15px',
                                        fontSize: '12px',
                                        marginTop: '5px',
                                        fontWeight: 'normal',
                                        textAlign: 'center'
                                    }}>You
                                        have {arrFilteredData.length} {arrFilteredData.length == 1 ? 'reservation' : 'reservations'} for month of: {today.toLocaleString('default', { month: 'long' })}</label>
                                </div>
                            )
                        })
                        }

                    </div>

                    <Scheduler
                        data={data}
                        // firstDayOfWeek={1}
                        height={700}
                        views={views}
                        //  adaptivityEnabled={true}
                        cellDuration={this.state.cellDurnotesQuestionIdation}
                    >
                        <ViewState
                            currentViewName={currentViewName} // Which UI to Render, currently it is "Week"
                            onCurrentViewNameChange={this.currentViewNameChange} // Change UI based on selection from drop-down on right side
                            // currentDate={currentDate} // current Date
                            onCurrentDateChange={this.currentDateChange} //Change Date based on selection from date range on left
                        />
                        <EditingState
                            onCommitChanges={this.commitChanges}
                            onEditingAppointmentChange={this.onEditingAppointmentChange}
                            onAddedAppointmentChange={this.onAddedAppointmentChange}
                        />
                        {/*<IntegratedEditing />*/}
                        <WeekView
                            name="week"
                            displayName="Week"
                            startDayHour={0}
                            endDayHour={24}
                            timeScaleLabelComponent ={SchedulerStyle}
                        />
                        <MonthView />
                        <DayView />
                        <Toolbar />
                        <ViewSwitcher />
                        <DateNavigator />
                        <TodayButton />
                        <EditRecurrenceMenu />
                        <Appointments
                            appointmentComponent={Appointment}
                        />
                        <Resources  data = {resourceData}/>
                        {/*<CurrentTimeIndicator*/}
                        {/*    indicatorComponent={TimeIndicator}*/}
                        {/*    shadePreviousCells*/}
                        {/*    shadePreviousAppointments*/}
                        {/*/>*/}
                        <AllDayPanel />
                        <AppointmentTooltip
                            showOpenButton
                            showDeleteButton
                            showCloseButton
                        />

                        <AppointmentForm
                            overlayComponent={this.appointmentForm}
                            visible={editingFormVisible}
                            onVisibilityChange={this.toggleEditingFormVisibility}
                            data = {this.state.questionDetails}
                        />
                        <Fab
                            color="secondary"
                            className={classes.addButton}
                            onClick={() => {
                                this.setState({ editingFormVisible: true, "questionDetails" : this.state.questionDetails });
                                this.onEditingAppointmentChange(undefined);
                                this.onAddedAppointmentChange({
                                });
                            }}
                        >
                            <AddIcon  className={classes.addIcon}/>
                        </Fab>
                        {/*<WeekView*/}
                        {/*    name="work-week"*/}
                        {/*    displayName="Work Week"*/}
                        {/*    excludedDays={[0, 6]}*/}
                        {/*    startDayHour={0}*/}
                        {/*    endDayHour={24}*/}
                        {/*/>*/}
                    </Scheduler>

                    <Dialog
                        open={confirmationVisible}
                        onClose={this.cancelDelete}
                    >
                        <DialogTitle>
                            Delete Appointment
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to delete this appointment?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.toggleConfirmationVisible} color="primary" variant="outlined">
                                Cancel
                            </Button>
                            <Button onClick={this.commitDeletedAppointment} color="secondary" variant="outlined">
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Paper>
            </div>
        )
    }
}
const mapStateToProps=(state)=> {
    return {
        appointment:state.appointmentReducer.appointment,
        questionDetails:state.appointmentReducer.questionDetails,
        user:state.loginResponse.results
    }
};
const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        getAppointment,
        deleteAppointment,
        addAppointment,
        updateAppointment,
        getQuestionDetails
    },dispatch)
};
export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(ReservationsTable));
